export default __webpack_public_path__ + "static/media/JackboxGames.9ac07b94.yaml";